import { useField } from 'formik'
import React from 'react'

import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { Radio, RadioOption } from 'app/components/ui/form/Radio'
import { addErrorDataAttribute } from './utils'
import { Label } from '../ui/form/Label'

interface Props {
  name: string
  options: RadioOption[]
  label?: string
  className?: string
}

export const SmartRadio: React.FC<Props> = ({
  name,
  options,
  label,
  className,
}) => {
  const [field, meta, helpers] = useField(name)
  const isInvalid = Boolean(meta.error && meta.touched)

  return (
    <div className={className}>
      {label && <Label>{label}</Label>}
      <Radio
        options={options}
        selectedValue={field.value}
        {...addErrorDataAttribute(meta)}
        onChange={newValue => {
          helpers.setValue(newValue)
        }}
      />
      {isInvalid ? (
        <FormFeedback variant='error'>{meta.error}</FormFeedback>
      ) : null}
    </div>
  )
}
